import type { Transition } from "@uirouter/core";

import { createBenchmarkTrackerApi } from "../services/api";
import type { BenchmarkUrlParams } from "../types/paramsTypes";

const getBenchmark = (transition: Transition) => {
    const api = createBenchmarkTrackerApi();
    const toParams = transition.params("to") as BenchmarkUrlParams;

    return api.benchmark.getBenchmarkById(toParams.key);
};

export const benchmarkResolver = {
    token: "benchmark",
    deps: ["$transition$"],
    resolveFn: getBenchmark,
};
